<div class="container container-width">
  <div class="topheadtitle">
    <h4>Day of week Usage Report </h4>
  </div>

  <div class="border-bottom-1 d-flex w-100 mb-10">
    <div class="form-box fw-600" [ngClass]="{'bg-white border-1': selectedTab === 'all'}">
      <button type="button" class="tab-button" [attr.aria-pressed]="selectedTab === 'all'"
        aria-label="Show All Report" (click)="selectedTab = 'all'; showTable = true">
        All Report
      </button>
    </div>
    <div class="ml-3 form-box fw-600" [ngClass]="{'bg-white border-1': selectedTab !== 'all'}">
      <button type="button" class="tab-button" [attr.aria-pressed]="selectedTab !== 'all'"
        aria-label="Show Search Report" (click)="selectedTab = 'search'; showTable = false">
        Search Report
      </button>
    </div>
  </div>


  @if (selectedTab === 'search') {
    <div class="w-100">
      <div class="border-bottom-1 p-3">
        <label for="reportType" class="form-box">Report Type</label>
        <select id="reportType" class="ml-3">
          <option>Invalid Submission</option>
          <option>Agency</option>
          <option>Agency-Details</option>
        </select>
      </div>
      <div class="form-box w-100 d-flex p-2" aria-labelledby="dow-creation-legend"
        aria-describedby="dow-creation-hint">
        <span id="dow-creation-legend" class="fw-600 mr-1">Creation Date</span>
        <input class="mr-1" id="creationStart" type="date" title="Search start date"
          aria-labelledby="dow-creation-legend" />
          <span class="mr-1" aria-hidden="true">to</span>
          <input class="mr-1" id="creationEnd" type="date" title="Search end date"
            aria-labelledby="dow-creation-legend" />
            <span id="dow-creation-hint" class="text-para ml-1">
              Enter just one date if a single date is desired.
            </span>
          </div>
          <button type="button" class="btn btn-primary btn-sm mt-3 mb-10" (click)="showTable = true;">Search</button>
        </div>
      }

      @if (showTable) {
        <div class="table-container w-100">
          <table summary="Day of week Usage Report ">
            <caption>Day of week Usage Report</caption>
            <thead>
              <tr>
                <th scope="col">Report Name</th>
                <th scope="col">Report Type</th>
                <th scope="col">Date Created</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <a href="javascript:void(0)">agency-invalid-submissions1.xml</a>
                </td>
                <td>Agency</td>
                <td>2015-05-14T22:17:32.673-05:00</td>
              </tr>
              <tr>
                <td>
                  <a href="javascript:void(0)">agency-invalid-submissions1.xml</a>
                </td>
                <td>Agency</td>
                <td>2015-05-14T22:17:32.673-05:00</td>
              </tr>
              <tr>
                <td>
                  <a href="javascript:void(0)">agency-invalid-submissions1.xml</a>
                </td>
                <td>Agency</td>
                <td>2015-05-14T22:17:32.673-05:00</td>
              </tr>
              <tr>
                <td>
                  <a href="javascript:void(0)">agency-invalid-submissions1.xml</a>
                </td>
                <td>Agency</td>
                <td>2015-05-14T22:17:32.673-05:00</td>
              </tr>
              <tr>
                <td>
                  <a href="javascript:void(0)">agency-invalid-submissions1.xml</a>
                </td>
                <td>Agency</td>
                <td>2015-05-14T22:17:32.673-05:00</td>
              </tr>
            </tbody>
          </table>
        </div>
      }
    </div>